
export const SvgPopularCities = () => (
  <svg
    width="1.5rem"
    height="1.5rem"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7985_12401)">
      <path
        d="M21.02 8.39C21.5 9.52 21.74 10.72 21.75 12C21.76 13.23 21.51 14.44 21.03 15.57C20.56 16.67 19.89 17.67 19.05 18.52C18.21 19.37 17.21 20.04 16.11 20.51C14.99 20.99 13.79 21.24 12.51 21.24C11.28 21.24 10.06 21 8.93 20.51C6.71 19.57 4.93 17.79 3.99 15.57C3.49 14.45 3.24 13.23 3.25 12C3.25 10.71 3.49 9.52 3.97 8.4C4.44 7.3 5.12 6.3 5.96 5.46C6.81 4.62 7.81 3.95 8.91 3.48C10.04 2.99 11.25 2.75 12.48 2.75C13.76 2.75 14.96 2.99 16.08 3.48H16.09C18.32 4.42 20.08 6.18 21.02 8.39Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.5" />
      <path
        d="M8.51999 16.7907L14.37 13.9007L17.26 8.04065C17.52 7.52065 16.97 6.97065 16.45 7.23065L10.59 10.1207L7.69999 15.9707C7.44999 16.5007 7.99999 17.0507 8.51999 16.7907ZM11.76 11.2707C12.17 10.8507 12.83 10.8407 13.26 11.2407C13.68 11.6507 13.69 12.3107 13.29 12.7407C12.88 13.1607 12.22 13.1707 11.79 12.7707C11.58 12.5707 11.46 12.2907 11.46 12.0107C11.46 11.7307 11.57 11.4607 11.76 11.2707Z"
        fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_7985_12401">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(2.5 2)" />
      </clipPath>
    </defs>
  </svg>
);
